/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StocktakeCountService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/StocktakeCount",
      top: "1",
      filter: `StocktakeCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async saveStocktakeCount(payload) {
    const url = `api/Save_StocktakeCount`;
    return await ApiService.post(url, payload);
  },
  async getStockTakeListItemById(code) {
    const requestScreenData = {
      url: "api/StocktakeList",
      top: "1",
      filter: `Code eq '${code}'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { StocktakeCountService };
